"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormLabel", {
    enumerable: true,
    get: function() {
        return FormLabel;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _Theme = require("../../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const FormLabel = (param)=>{
    let { children, required = false, htmlFor, id, inline = false, textWrap = false, noMargin = false, capitalize = true } = param;
    const { colors, spacers, isAdmin, breakpoints } = (0, _Theme.useTheme)();
    const { styles: inlineResponsiveStyles, className } = typeof inline !== "string" ? {
        styles: /*#__PURE__*/ _react.default.createElement(_style.default, {
            id: "b3e1b6a7c9b96113"
        }, ""),
        className: "jsx-b3e1b6a7c9b96113"
    } : {
        styles: /*#__PURE__*/ _react.default.createElement(_style.default, {
            id: "58d5900c28a6e9b",
            dynamic: [
                breakpoints[inline],
                spacers.s2
            ]
        }, "@media screen (max-width: ".concat(breakpoints[inline], "px) {div.__jsx-style-dynamic-selector{padding:").concat(spacers.s2, " 0}}")),
        className: _style.default.dynamic([
            [
                "58d5900c28a6e9b",
                [
                    breakpoints[inline],
                    spacers.s2
                ]
            ]
        ])
    };
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "42394121daa92ec8",
                [
                    isAdmin ? "flex-start" : "space-between",
                    isAdmin ? "initial" : "flex-start",
                    inline !== false ? spacers.s4 : noMargin ? spacers.s0 : spacers.s2,
                    isAdmin ? "12" : "14",
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? spacers.s1 : spacers.s3,
                    isAdmin && !noMargin ? spacers.s3 : "0",
                    textWrap ? "wrap" : undefined,
                    isAdmin && capitalize ? "uppercase" : undefined,
                    spacers.s1
                ]
            ]
        ]) + " " + (className || "")
    }, /*#__PURE__*/ _react.default.createElement("label", {
        id: id,
        htmlFor: htmlFor,
        className: _style.default.dynamic([
            [
                "42394121daa92ec8",
                [
                    isAdmin ? "flex-start" : "space-between",
                    isAdmin ? "initial" : "flex-start",
                    inline !== false ? spacers.s4 : noMargin ? spacers.s0 : spacers.s2,
                    isAdmin ? "12" : "14",
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? spacers.s1 : spacers.s3,
                    isAdmin && !noMargin ? spacers.s3 : "0",
                    textWrap ? "wrap" : undefined,
                    isAdmin && capitalize ? "uppercase" : undefined,
                    spacers.s1
                ]
            ]
        ])
    }, children, required ? /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "42394121daa92ec8",
                [
                    isAdmin ? "flex-start" : "space-between",
                    isAdmin ? "initial" : "flex-start",
                    inline !== false ? spacers.s4 : noMargin ? spacers.s0 : spacers.s2,
                    isAdmin ? "12" : "14",
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? spacers.s1 : spacers.s3,
                    isAdmin && !noMargin ? spacers.s3 : "0",
                    textWrap ? "wrap" : undefined,
                    isAdmin && capitalize ? "uppercase" : undefined,
                    spacers.s1
                ]
            ]
        ]) + " " + "required-marker"
    }, "*") : null), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "42394121daa92ec8",
        dynamic: [
            isAdmin ? "flex-start" : "space-between",
            isAdmin ? "initial" : "flex-start",
            inline !== false ? spacers.s4 : noMargin ? spacers.s0 : spacers.s2,
            isAdmin ? "12" : "14",
            isAdmin ? colors.medium : colors.dark,
            isAdmin ? spacers.s1 : spacers.s3,
            isAdmin && !noMargin ? spacers.s3 : "0",
            textWrap ? "wrap" : undefined,
            isAdmin && capitalize ? "uppercase" : undefined,
            spacers.s1
        ]
    }, "div.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:".concat(isAdmin ? "flex-start" : "space-between", ";-webkit-justify-content:").concat(isAdmin ? "flex-start" : "space-between", ";-moz-box-pack:").concat(isAdmin ? "flex-start" : "space-between", ";-ms-flex-pack:").concat(isAdmin ? "flex-start" : "space-between", ";justify-content:").concat(isAdmin ? "flex-start" : "space-between", ";-webkit-box-align:").concat(isAdmin ? "initial" : "flex-start", ";-webkit-align-items:").concat(isAdmin ? "initial" : "flex-start", ";-moz-box-align:").concat(isAdmin ? "initial" : "flex-start", ";-ms-flex-align:").concat(isAdmin ? "initial" : "flex-start", ";align-items:").concat(isAdmin ? "initial" : "flex-start", ";padding:").concat(inline !== false ? spacers.s4 : noMargin ? spacers.s0 : spacers.s2, " 0;-o-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}label.__jsx-style-dynamic-selector{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;font-weight:500;font-size:").concat(isAdmin ? "12" : "14", "px;color:").concat(isAdmin ? colors.medium : colors.dark, ";padding-right:").concat(isAdmin ? spacers.s1 : spacers.s3, ";margin:0;margin-bottom:").concat(isAdmin && !noMargin ? spacers.s3 : "0", ";-o-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden;display:inline-block;white-space:nowrap;text-wrap:").concat(textWrap ? "wrap" : undefined, ";text-transform:").concat(isAdmin && capitalize ? "uppercase" : undefined, "}.required-marker.__jsx-style-dynamic-selector{color:red;font-size:14px;margin-left:").concat(spacers.s1, ';font:"Roboto"}')), inlineResponsiveStyles);
};

//# sourceMappingURL=FormLabel.js.map